var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66363 12.0001C5.66363 11.238 5.79021 10.5073 6.01613 9.82198L2.06172 6.80225C1.29103 8.36705 0.856812 10.1302 0.856812 12.0001C0.856812 13.8684 1.29049 15.6305 2.06012 17.1942L6.01239 14.1686C5.78861 13.4865 5.66363 12.7585 5.66363 12.0001Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6069 5.0666C14.2625 5.0666 15.758 5.65327 16.933 6.61327L20.3512 3.19993C18.2682 1.3866 15.5978 0.266602 12.6069 0.266602C7.96347 0.266602 3.97274 2.92207 2.06177 6.80207L6.01618 9.8218C6.92734 7.05594 9.52462 5.0666 12.6069 5.0666Z",
    fill: "#EB4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6069 18.9334C9.52462 18.9334 6.92734 16.9441 6.01618 14.1782L2.06177 17.1974C3.97274 21.078 7.96347 23.7334 12.6069 23.7334C15.4728 23.7334 18.2089 22.7158 20.2625 20.8092L16.5089 17.9073C15.4498 18.5745 14.1162 18.9334 12.6069 18.9334Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8227 12C23.8227 11.3067 23.7159 10.56 23.5557 9.8667H12.6068V14.4H18.9091C18.594 15.9456 17.7362 17.1339 16.5089 17.9072L20.2625 20.8091C22.4197 18.807 23.8227 15.8246 23.8227 12Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.d30a1320af1905a1b3eb71618ecda3f7.svg";
export { ForwardRef as ReactComponent };